
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VeeValidate, { Validator } from 'vee-validate';
import VueAnalytics from 'vue-analytics';
import App from './App'
import router from './router'
import store from '@/store/store'
import { i18n } from '@/i18n';

Vue.use(Vuex);
axios.defaults.baseURL = store.state.server;

var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
  offset: -120,
})
Vue.config.productionTip = false


//ANALYTICS
/* if (location.hostname.includes('dev') == false && location.hostname.includes('localhost') == false) {
  Vue.use(VueAnalytics, {
    id: 'UA-117270-3',
    router,
  });
} */
// Eventos para añadir arguments al dataLayer
Vue.mixin({
	methods: {
		eventGA(value) {
      window.dataLayer.push({ 'event': value });
		},
	}
})

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  VeeValidate,
  VueScrollTo,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js